import PubSub from 'vanilla-pubsub'
import clickOutSide from 'click-outside'
import projectBase from '../projectBase'

import { wait } from '../utils'

export default class Modal {
  constructor(selector) {
    this.el = document.querySelector(selector)

    this.state = {
      active: false,
      isLoading: false,
    }

    this.options = {
      triggerSelector: '[data-modal-trigger]',
      contentSelector: '[data-modal-content]',
    }

    if (this.el) {
      this.initialize()
    }
  }

  /**
   * 初期化
   */
  initialize() {
    const styleDuration = getComputedStyle(this.el).transitionDuration || '0s'

    // モーダル表示に必要な要素を取得
    this.$modalContent = this.el.querySelector(this.options.contentSelector)
    // モーダル要素に指定されているtransitionDurationを取得
    this.transitionDuration = parseFloat(styleDuration) * 1000

    this.bind()
  }

  /**
   * イベントハンドラをバインド
   */
  bind() {
    this.toggle = this.toggle.bind(this)
    this.disable = this.disable.bind(this)

    // モーダルトリガーにトグルイベントを追加
    ;[...document.querySelectorAll(this.options.triggerSelector)].forEach(
      (trigger) => {
        let options

        if (trigger.dataset.options) {
          try {
            options = JSON.parse(trigger.dataset.options)
          } catch (err) {
            console.error(err)
          }
        }

        trigger.$modal = options
        trigger.addEventListener('click', this.toggle)
      }
    )

    this.unbind = clickOutSide(this.$modalContent, () => {
      if (!this.state.active) return
      this.disable()
    })
  }

  /**
   * モーダルを表示
   */
  async active(targetName, options = {}) {
    // トリガーに指定されているターゲットに対応する要素を取得
    const targetTemplate = document.querySelector(
      `[data-modal-name="${targetName}"]`
    )

    // モーダル要素の内部コンテンツを更新
    this.$modalContent.innerHTML = targetTemplate.innerHTML

    // 連携するモジュールがある場合はここでイベントをdispatchします
    if (options.dispatches || options.dispatches instanceof Array) {
      this.instances = {}

      // options.dispatches.forEach((name) => {
      // })
    }

    this.el.classList.add('is-show')

    await wait(10)

    this.el.classList.add('is-active')
    this.state.active = true

    PubSub.publish('App.methods.scroll.disable')
    PubSub.publish('Modal.active')
  }

  /**
   * モーダルを非表示に
   */
  async disable() {
    this.el.classList.remove('is-active')

    await wait(this.transitionDuration)
    this.el.classList.remove('is-show')

    this.$modalContent.innerHTML = ''
    this.state.active = false

    PubSub.publish('App.methods.scroll.release')
    PubSub.publish('Modal.disable')
  }

  /**
   * トグルハンドラー
   */
  async toggle(e) {
    e.preventDefault()

    // // ステート上のローディングを有効化
    // if (this.state.isLoading) return
    // this.state.isLoading = true

    // モーダルのターゲット名を取得
    const $trigger = e.currentTarget
    const targetName =
      $trigger instanceof HTMLElement ? $trigger.dataset.modalTarget : ''

    // 現在のステートにあわせて、表示をトグル
    if (this.state.active) {
      await this.disable()
    } else {
      await this.active(targetName, $trigger.$modal || {})
    }

    // // ローディングを無効化
    // this.state.isLoading = false
  }
}
